export const getHeight = (): string => {
  if (document.documentElement && document.documentElement.clientHeight) {
    return String(document.documentElement.clientHeight);
  }

  if (document.body) {
    return String(document.body.clientHeight);
  }

  return '0';
};
